// PrivateRoute.tsx

import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Route, RouteProps } from "react-router";
import firebase from "firebase/compat/app";
import { isEmpty } from "lodash";
import { isAuthorizedUser } from "../util/util";
import UpgradeDialog from "../pages/common/UpgradeDialog";

interface PrivateRouteProps extends RouteProps {
  path: string;
  component: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  path,
  component: Component,
  ...rest
}) => {
  const [authorized, setAuthorized] = useState(true);
  const [userData, setUserData] = useState({});

  const getUser = async (userId: any) => {
    const userDoc = await firebase
      .firestore()
      .collection("userx")
      .doc(userId)
      .get();
    const userData = (userDoc.data() as any) || {};
    setUserData(userData);
  };

  useEffect(() => {
    const { computedMatch } = rest as any;
    if (computedMatch && computedMatch.params.userId) {
      getUser(computedMatch.params.userId);
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(userData)) {
      setAuthorized(isAuthorizedUser(userData));
    }
  }, [userData]);

  if (!authorized) {
    return (
      <UpgradeDialog
        upgradeDialogOpen={true}
        onClose={() => {}}
        onConfirm={() => window.open("https://flowcharts.ai#pricing", "_blank")}
        disableEscapeKeyDown
      />
    );
  }

  return (
    <Route path={path} {...rest} render={(props) => <Component {...props} />} />
  );
};

export default PrivateRoute;
